import { gql } from 'graphql-request';

import type { MaterialID, MaterialUUID } from '../materialsTypes';
import type { CategoryID } from '../../categories/categoriesTypes';

export interface CacheFetchMaterialsAggregationsQueryResponse {
  id: MaterialID;
  uuid: MaterialUUID;
}

interface AggregationsItem {
  id: CategoryID;
  name: string;
}

export interface CacheFetchMaterialsAggregationsQueryResponseAggregations {
  brands?: AggregationsItem[];
  categories?: AggregationsItem[];
}

export const CACHE_FETCH_MATERIALS_AGGREGATIONS_QUERY = gql`
  query CacheMaterialsAggregations(
    $filters: MaterialsFilters
    $sort: [MaterialsSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
    $aggregations: Boolean
  ) {
    materials(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
      aggregations: $aggregations
    ) {
      aggregations
      nodes {
        id
        uuid
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
